import { API } from "aws-amplify";
import { useCallback } from "react";
import { GraphQLQuery } from "@aws-amplify/api";

import { setPaymentMethod as setPaymentMethodGqlMutation } from "../graphql/mutations";
import {
    SetPaymentMethodInput,
    SetPaymentMethodMutation,
    CreatePaymentResponse,
} from "../API";

type UsePaymentMethodResponse = Partial<CreatePaymentResponse> & {
    error?: string;
    errorType?: string;
};

export function useSetPaymentMethod() {
    const setPaymentMethod = useCallback(
        async (
            input: SetPaymentMethodInput
        ): Promise<UsePaymentMethodResponse | null> => {
            try {
                const result = await API.graphql<
                    GraphQLQuery<SetPaymentMethodMutation>
                >({
                    query: setPaymentMethodGqlMutation,
                    variables: { input },
                });

                if (result.errors) {
                    return { error: result.errors[0].message };
                }

                return result.data?.setPaymentMethod || null;
            } catch (e: any) {
                console.log("[setPaymentMethod]", e);
                return {
                    error: e.errors[0].message,
                    errorType: e.errors[0].errorType,
                };
            }
        },
        []
    );

    return { setPaymentMethod };
}
